import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRoutesList = createAsyncThunk("fetchRoutesList", async ({ id, page, limit }) => {
	const params = new URLSearchParams({
		page,
		limit,
	});

	const response = await axiosHttp.get(`channels/routes?${params}`);
	return response.data.data;
});

const RoutesListSlice = createSlice({
	name: "RoutesListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRoutesList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchRoutesList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchRoutesList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RoutesListSlice.reducer;
